import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EventCard from "./components/EventCard";
// Firestore imports removed
import { ApiService } from "../../services/api_service";

const AllEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await ApiService.getAllEvents();
        // Handle response. data usually contains the list or map.
        let fetchedEvents = response.data || response;

        // If fetchedEvents is an object/map, convert to array
        if (fetchedEvents && !Array.isArray(fetchedEvents) && typeof fetchedEvents === 'object') {
          fetchedEvents = Object.values(fetchedEvents);
        }

        if (!Array.isArray(fetchedEvents)) {
          console.error("Unexpected events data format", fetchedEvents);
          fetchedEvents = [];
        }

        const eventsData = fetchedEvents.filter(event =>
          event.showInApp === true || event.showInApp === null || event.showInApp === undefined
        );

        // Sort events by startTime
        const sortedEvents = eventsData.sort((b, a) => {
          const dateA = a.startTime ? new Date(a.startTime) : new Date(0);
          const dateB = b.startTime ? new Date(b.startTime) : new Date(0);
          return dateA - dateB;
        });

        setEvents(sortedEvents);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching events:", error);
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  if (loading) {
    return (
      <div className="bg-[#111] text-white min-h-screen flex items-center justify-center">
        <div className="text-xl">Loading events...</div>
      </div>
    );
  }

  return (
    <div className="bg-[#111] text-white min-h-screen">
      {/* Header */}
      <div className="px-4 md:px-[60px] pt-[100px] pb-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <Link
              to="/"
              className="text-white/70 hover:text-white transition-colors duration-300 mb-2 inline-block"
            >
              ← Back to Home
            </Link>
            <h1 className="text-white font-['Poppins'] text-3xl font-medium">
              All Events
            </h1>
          </div>
          <div className="text-white/70">
            {events.length} events found
          </div>
        </div>
      </div>

      {/* Events Grid */}
      <div className="px-4 md:px-[60px] pb-[60px]">
        {events.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            {events.map((event) => (
              <EventCard key={event.id} event={event} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="text-white/70 text-xl mb-4">No events found</div>
            <Link
              to="/"
              className="text-white hover:text-gray-300 transition-colors duration-300"
            >
              Return to Home
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllEvents;

